"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colorPalette = _interopRequireDefault(require("./colorPalette"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultTheme = {
  // Base background colors. The color-background variable and its variants are
  // the primary backgrounds for the application. These will usually be white or
  // light grey for light-colored themes, while the color-background-contrast
  // group will be dark grey/black. For dark themes, these groups would be
  // reversed (color-background black, color-background-contrast white).
  colorBackgroundLight: _colorPalette.default.white,
  colorBackground: _colorPalette.default.neutralLighter,
  colorBackgroundDark: _colorPalette.default.neutralLight,
  colorBackgroundContrastLight: _colorPalette.default.neutralLight,
  colorBackgroundContrast: _colorPalette.default.neutralMed,
  colorBackgroundContrastDark: _colorPalette.default.neutralDark,
  colorBorder: _colorPalette.default.neutralMed,
  // Theme primary and accent colors
  colorPrimaryLight: _colorPalette.default.primaryLight,
  colorPrimary: _colorPalette.default.primary,
  colorPrimaryDark: _colorPalette.default.primaryDark,
  colorPrimaryDarker: _colorPalette.default.stormy,
  colorAccent: _colorPalette.default.accent,
  colorAccentDark: _colorPalette.default.accentDark,
  colorNeutralLight: _colorPalette.default.neutralLight,
  colorNeutral: _colorPalette.default.neutralMed,
  colorNeutralDark: _colorPalette.default.neutralDark,
  // Success/error message coloring
  colorInfo: _colorPalette.default.primaryDark,
  colorSuccess: _colorPalette.default.primaryLight,
  colorWarning: _colorPalette.default.yellow,
  colorError: _colorPalette.default.accent,
  // Text colors
  colorTextPrimary: _colorPalette.default.neutralDark,
  colorTextSecondary: _colorPalette.default.neutralMed,
  colorTextDisabled: _colorPalette.default.neutralLight,
  colorTextAccent: _colorPalette.default.primaryDark,
  colorTextOnContrastLight: _colorPalette.default.neutralDark,
  colorTextOnContrast: _colorPalette.default.neutralDarker,
  colorTextOnContrastDark: _colorPalette.default.white,
  colorTextOnPrimaryLight: _colorPalette.default.neutralDark,
  colorTextOnPrimary: _colorPalette.default.white,
  colorTextOnPrimaryDark: _colorPalette.default.white,
  colorTextOnPrimaryDarker: _colorPalette.default.white,
  colorTextOnAccent: _colorPalette.default.white,
  colorTextOnAccentDark: _colorPalette.default.white,
  colorTextOnNeutralLight: _colorPalette.default.neutralDark,
  colorTextOnNeutral: _colorPalette.default.white,
  colorTextOnNeutralDark: _colorPalette.default.white,
  // Focus indicator settings
  focusIndicator: "2px dotted ".concat(_colorPalette.default.neutralDark),
  focusIndicatorContrast: "2px dotted ".concat(_colorPalette.default.neutralLighter),
  focusIndicatorOffset: '2px',
  focusIndicatorInset: '-2px',
  // Spacing variables for white space or spacing within and between components
  spacingXs: '4px',
  spacingS: '8px',
  spacingM: '16px',
  spacingL: '24px',
  spacingXl: '32px',
  spacingXxl: '64px',
  spacingXxxl: '96px'
};
var _default = defaultTheme;
exports.default = _default;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/core/Theme/defaultTheme.js